export default {
  title: 'Começar',
  description: 'Para carregar a página atual, deve completar o guia Começar',
  button: 'Começar',
};
